export const safeAtob = (input: string): string | null => {
  try {
    return window.atob(input);
  } catch {
    return null;
  }
};

export const safeBtoa = (input: string): string | null => {
  try {
    return window.btoa(input);
  } catch {
    return null;
  }
};
